import { handleActions } from 'redux-actions';
import { calculateOverallProgress, handleChunksProgress } from './utils';
import {
  CHUNK_UPLOAD_PROGRESS,
  UPLOAD_FORM_CONFIG_SUCCESS,
  UPLOAD_INIT_VIDEO_OBJECT_SUCCESS,
  UPLOAD_PUBLISH_SUCCESS,
  UPLOAD_RESET,
  UPLOAD_INIT_VIDEO_OBJECT_REQUEST,
} from './actions';

const initialState = {
  uploadFiled: false,
  videoInitObject: null,
  videoUploadProgress: 0,
  videoIsPublished: false,
  skipSelectVideo: false,
  videoIsUnsupported: false,
  uploadFormConfig: null,
  chunksProgress: null,
  totalChunks: 0,
};

/**
 * @param prevState
 * @param {{payload: {progress: number, forChunk: number, totalChunks:number}}} action
 * @return {*}
 */
export const chunkUploadProcessHandle = (prevState, { payload: { progress, forChunk, totalChunks } }) => {
  const chunksProgress = {
    ...handleChunksProgress(prevState.chunksProgress, totalChunks),
    [forChunk]: progress,
  };
  const videoUploadProgress = calculateOverallProgress(chunksProgress);
  return {
    ...prevState,
    totalChunks,
    chunksProgress,
    videoUploadProgress,
    skipSelectVideo: false,
  };
};

export const uploadPageReducer = handleActions(
  {
    [UPLOAD_INIT_VIDEO_OBJECT_REQUEST]: (prevState, { payload: { skipSelectVideo } }) => ({
      ...prevState,
      skipSelectVideo: skipSelectVideo,
    }),

    [UPLOAD_INIT_VIDEO_OBJECT_SUCCESS]: (prevState, { payload: { video } }) => ({
      ...prevState,
      videoInitObject: video,
    }),

    [UPLOAD_RESET]: () => initialState,

    [CHUNK_UPLOAD_PROGRESS]: chunkUploadProcessHandle,

    [UPLOAD_PUBLISH_SUCCESS]: (prevState, { payload: { video } }) => ({
      ...prevState,
      videoIsPublished: true,
      videoInitObject: {
        ...prevState.videoInitObject,
        ...{ video },
      },
    }),

    [UPLOAD_FORM_CONFIG_SUCCESS]: (prevState, { payload: { uploadFormConfig } }) => ({
      ...prevState,
      uploadFormConfig,
    }),
  },
  initialState
);
